(() => {
  const scopeSelector = 'main, #MainContent, header, footer, .hdt-footer, .shopify-section-group-header-group, .shopify-section-group-footer-group';
  const excluded = '.spot-brand-name, script, style, noscript, textarea, input, select, option, pre, code, svg, math, iframe, [contenteditable], .shopify-app-block, [data-spot-brand-ignore]';
  const pattern = /\bSpot[ \u00a0]+Studio(?:[ \u00a0]+Art)?\b/gi;
  const pending = new Set();
  let scheduled = false;

  function eligible(node) {
    const parent = node.parentElement;
    return parent && parent.closest(scopeSelector) && !parent.closest(excluded) && /\bSpot[ \u00a0]+Studio\b/i.test(node.data);
  }

  function wrap(node) {
    if (!eligible(node)) return;
    const text = node.data;
    const fragment = document.createDocumentFragment();
    let offset = 0;
    pattern.lastIndex = 0;
    for (const match of text.matchAll(pattern)) {
      fragment.append(document.createTextNode(text.slice(offset, match.index)));
      const brand = document.createElement('span');
      brand.className = 'spot-brand-name';
      brand.textContent = match[0];
      fragment.append(brand);
      offset = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(text.slice(offset)));
    node.replaceWith(fragment);
  }

  function scan(root) {
    if (!root.isConnected) return;
    if (root.nodeType === Node.TEXT_NODE) { wrap(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) if (eligible(walker.currentNode)) nodes.push(walker.currentNode);
    nodes.forEach(wrap);
  }

  function queue(root) {
    pending.add(root);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const roots = [...pending];
      pending.clear();
      roots.forEach(scan);
    });
  }

  document.querySelectorAll(scopeSelector).forEach(scan);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') queue(record.target);
      else record.addedNodes.forEach(queue);
    }
  });
  // Read only text nodes in known storefront scopes; never rewrite HTML or attributes.
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
})();
